import { PlanningWorkPackageSlider } from '@bechtel/client-common';
import { Scalars } from '@bechtel/types';
import styled, { css } from 'styled-components';

interface WorkPackageItemContainerProps {
  selected: Scalars['Boolean'];
  planningWorkPackageSlider: PlanningWorkPackageSlider;
}
export const WorkPackageItemContainer = styled.div<WorkPackageItemContainerProps>`
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.grey[300]};
    color: inherit;
    display: block;
    padding-top: ${theme.spacings[500]};
    padding-left: ${theme.spacings[400]};
    padding-right: ${theme.spacings[400]};
    padding-bottom: ${theme.spacings[500]};
    position: relative;
    text-decoration: none;
    transition-timing-function: ease-in-out;
    transition-duration: 80ms;
    transition-property: background-color;
    cursor: pointer;
    &.active,
    &:hover {
      background-color: ${theme.colors.bechtel.blue[100]};
    }
    ${(props: WorkPackageItemContainerProps) =>
      props.selected &&
      css`
        background-color: ${({ theme }) => theme.colors.bechtel.blue[100]};
      `}
    ${(props: WorkPackageItemContainerProps) =>
      props.planningWorkPackageSlider === PlanningWorkPackageSlider.All &&
      css`
        pointer-events: none;
      `}
  `}
`;
